import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  public loading = false;
  
  constructor(private authService:AuthService,public flashMessagesService: FlashMessagesService,
    public router:Router) { }

  ngOnInit() {
    
  }
  onSignin(form:NgForm){
    this.loading=true;
    const email=form.value.email;
    const password=form.value.password;
    this.authService.signinUser(email,password)
    .catch((err)=>{
      this.loading=false;
    });
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/auth/signin/signin.component.ts